export default {
  navMenuItems({ commit }) {
    commit('SET_NAV_MENU_ITEMS');
  },
  clearNavMenuItems({ commit }) {
    commit('CLEAR_NAV_MENU_ITEMS');
  },
}